import { Component, ReactNode } from "react";
import ErrorState from "./ErrorState";

/** Falha ao baixar um pedaço do bundle (deploy novo trocou os hashes, rede caiu). */
export const isChunkLoadError = (error: unknown) => {
  const e = error as { name?: unknown; message?: unknown } | null;
  return e?.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed|dynamically imported module/i.test(String(e?.message ?? ""));
};

type Props = { children?: ReactNode; onReload?: () => void };
type State = { error: unknown };

/**
 * Envolve rotas `lazy`: se o chunk não carrega, mostra "Recarregar" em vez da tela branca.
 * Outros erros seguem para o boundary de cima (relançados no render).
 */
export default class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (!isChunkLoadError(error)) throw error;
    const reload = this.props.onReload ?? (() => window.location.reload());
    return (
      <ErrorState
        title="Não foi possível abrir esta tela"
        description="Uma versão nova do painel pode ter sido publicada. Recarregue a página para continuar."
        onRetry={reload}
        retryLabel="Recarregar"
      />
    );
  }
}
